import { createContext } from 'react';

const NodeContext = createContext(null);
export default NodeContext;
